import { kNIHFunctionalStatementsFieldID } from "../constants";

// Normalize a field identifier for tolerant matching of the NIH functional
// statements field. Charts carry this field under varying labels
// ("Functional Statements", "Functional Statement", "functional_statements"),
// and on V3 charts GetFieldDefByID is case-sensitive, so an exact-case, exact-text
// lookup silently misses. Strip case, whitespace, punctuation and a trailing plural
// so all those variants collapse to one key. Keep this the single source of truth so
// every consumer (panel, subchart layout, export) resolves the field identically.
function normalizeFieldID(value) {
  return String(value)
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .replace(/S$/, "");
}

const kNormalizedFunctionalStatementID = normalizeFieldID(kNIHFunctionalStatementsFieldID);

/**
 * Resolve the functional statements field def on a box/object class, tolerating
 * case/whitespace/punctuation/plural variations in the chart's field label.
 *
 * @param {object | null | undefined} boxClass
 * @returns {import("../CoreApp/QObjDBFieldDef").QObjDBFieldDef | null} the matching field def, or null
 */
export function GetFunctionalStatementFieldDef(boxClass) {
  if (!boxClass) return null;

  // Fast path: exact canonical-case match (already case-insensitive on V1/V2 charts).
  var fieldDef = boxClass.GetFieldDefByID(kNIHFunctionalStatementsFieldID);
  if (fieldDef) return fieldDef;

  // Relaxed scan for label variants (the V3 case-sensitive path).
  var n = boxClass.GetFieldCount();
  for (var i = 0; i < n; i++) {
    var candidate = boxClass.GetIndexFieldDef(i);
    if (
      candidate &&
      normalizeFieldID(candidate.GetFieldID()) === kNormalizedFunctionalStatementID
    ) {
      return candidate;
    }
  }

  return null;
}
